import request from '@/services/interceptor.js'

export const get_clienti = () => {
    return request({
        url: '/cliente',
        method: 'get',
        loadingBar: true
    })
}

export const get_cliente = (id) => {
    return request({
        url: `/cliente/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_cliente = (par) => {
    return request({
        url: '/cliente',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_cliente = (id, par) => {
    return request({
        url: `/cliente/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_cliente = (id) => {
    return request({
        url: `/cliente/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_cliente = (id) => {
    return request({
        url: `/cliente/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
